module.exports = __webpack_public_path__ + "static/media/method-linking.6fe45088.svg";